module.exports = __webpack_public_path__ + "static/media/fly0078.6fbe0e22.webp";